import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';
import { createActions } from '../../../../store';
import { BAR_COUNT_STEP, MIN_BAR_COUNT, MAX_BAR_COUNT, WAVE_STYLE } from '../../../../Preview/PreviewDisplayConstants';
import { previewHistoryBatch } from '../../../../store/extensions';

const getBarCountLimits = (reflectionType) => {
    return {
        step: BAR_COUNT_STEP[reflectionType] || 1,
        min: MIN_BAR_COUNT[reflectionType] || 4,
        max: MAX_BAR_COUNT[reflectionType] || 200
    };
};

const WaveLayerCountListItem = memo((props) => {
    const { 
        index, 
        visualizerBarCount, 
        visualizerWaveStyle, 
        visualizerReflectionType,
        updateWaveLayerCustomOptions 
    } = props;

    const { step, min, max } = getBarCountLimits(visualizerReflectionType);
    const title = visualizerWaveStyle === WAVE_STYLE.BAR ? 'Bar Count' : 'Point Count';
    const toolTip = visualizerWaveStyle === WAVE_STYLE.POINT ? null  : `The number of ${visualizerWaveStyle === WAVE_STYLE.BAR ? "bars" : "points"} used to draw the wave.`;

    const onCountChange = useCallback((value) => {
        previewHistoryBatch.start();
        updateWaveLayerCustomOptions(index, "barCount", value);
    }, [index]);

    return (
        <SliderListItem
            title={title}
            preventRound
            value={visualizerBarCount}
            displayMultiplier={1}
            min={min}
            max={max}
            step={step}
            onValueChange={onCountChange}
            toolTip={toolTip}
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const {
        barCount: visualizerBarCount,
        waveStyle: visualizerWaveStyle,
        reflectionType: visualizerReflectionType
    } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;

    return {
        visualizerBarCount,
        visualizerWaveStyle,
        visualizerReflectionType
    };
};

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerCountListItem);